import { render, staticRenderFns } from "./SubUnitEditButton.vue?vue&type=template&id=65aa1e05&scoped=true&"
import script from "./SubUnitEditButton.vue?vue&type=script&lang=ts&"
export * from "./SubUnitEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubUnitEditButton.vue?vue&type=style&index=0&id=65aa1e05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa1e05",
  null
  
)

export default component.exports